// ChatDefaultRenderer.js
'use strict';
import { connect } from 'react-redux';

import ChatDefaultRenderer from '../page/ChatDefaultRenderer.jsx';
import { chatroomListType } from '../resource/chatroomConstants.js';
import getListData from '../selector/getListData.js';
import getMeData from '../selector/getMeData.js';
import getOperationData from '../selector/getOperationData.js';
import { breakpoint } from '../style/variables.js';

const mapStateToProps = state => {
  const hasChatroom = !!getListData(
    state,
    ['chatrooms', chatroomListType.ALL],
    'itemIds'
  )?.length;

  return {
    hasChatroom,
    isAuthed: !!getMeData(state, 'id'),
    isOnDesktop:
      getOperationData(state, ['device'], 'width') > breakpoint.mobile,
  };
};

export default connect(mapStateToProps)(ChatDefaultRenderer);
